// This file was generated automatically as a part of the SourceWhale ES6 refactor 🐳.
import "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_reset.scss";
import "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_typography.scss";
import "../../css/pages/_contacts.scss";

import { initializeGeneralUtils } from "@sourcewhale/shared/src/assets/js/src/general/utils";
import { bindDialler } from "../../../svelte/src/bindings/dialler.js";
import { bindSearchSignpostBanner } from "../../../svelte/src/bindings/search-signpost-banner.js";
import { initializeSidebar } from "../../../svelte/src/bindings/sidebar.js";
import { bindSystemBannerNotifications } from "../../../svelte/src/bindings/system-banner-notifications";
import { bindTestPanel } from "../../../svelte/src/bindings/test-panel-prod.js";
import { bindTodosModal } from "../../../svelte/src/bindings/todos-modal.js";
import { initializeContactUtils } from "../src/contact-utils.js";
import { initializeConfig } from "../src/general/config.js";
import { initializeCleartext } from "../src/general/elements/cleartext.js";
import { initializeTheme } from "../src/general/theme.js";
import { initializeTracking } from "../src/general/tracking.js";
import { initializeVisibilities } from "../src/general/visibilities.js";
import { initializeMarketingModal } from "../src/marketing/marketing.js";
import { initializeContacts } from "../src/sidebar/contacts.js";
import { initializeUploads } from "../src/uploads/uploads.js";
import { initializeWins } from "../src/wins/wins.js";

bindTestPanel();
bindSystemBannerNotifications();
bindTodosModal();
bindDialler();
bindSearchSignpostBanner();
initializeTheme();
initializeConfig();
initializeGeneralUtils();
initializeVisibilities();
initializeContactUtils();
initializeContacts();
initializeSidebar();
initializeCleartext();
initializeTracking();
initializeWins();
initializeUploads();
initializeMarketingModal();
